import script from "./database.vue?vue&type=script&setup=true&lang=js"
export * from "./database.vue?vue&type=script&setup=true&lang=js"

import "./database.vue?vue&type=style&index=0&id=7d5c129e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d5c129e"]])

export default __exports__